var _circle, _circle2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyRiderRoutes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23864_34756)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46.0002,
    r: 35,
    fill: "#E4DCF3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23864_34756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 70,
    height: 70
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 35,
    fill: "#E4DCF3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23864_34756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.915,
    y: 26.6382,
    width: 47.6596,
    height: 55.1064,
    rx: 1.86701,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.1289,
    y: 39.2998,
    width: 35.7447,
    height: 4.46809,
    rx: 0.875,
    fill: "#F9F7FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1289,
    y: 52.7041,
    width: 35.7447,
    height: 4.46809,
    rx: 0.875,
    fill: "#F9F7FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1289,
    y: 46.0022,
    width: 35.7447,
    height: 4.46809,
    rx: 0.875,
    fill: "#F9F7FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1289,
    y: 59.4062,
    width: 35.7447,
    height: 4.46809,
    rx: 0.875,
    fill: "#F9F7FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1289,
    y: 66.1084,
    width: 28.2979,
    height: 4.46809,
    rx: 0.875,
    fill: "#F9F7FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3123 30.9965H38.9377V34.6187H38.2866L36.769 32.0731V34.6187H36.1436V30.9965H36.7896L38.3123 33.5292V30.9965ZM40.8322 34.6699C40.04 34.6699 39.5197 34.0573 39.5197 33.3318C39.5197 32.6089 40.04 32.0039 40.8322 32.0039C41.6243 32.0039 42.1447 32.6089 42.1447 33.3318C42.1447 34.0573 41.6243 34.6699 40.8322 34.6699ZM40.8322 34.1316C41.3064 34.1316 41.4935 33.7522 41.4935 33.3318C41.4935 32.9114 41.3064 32.5448 40.8322 32.5448C40.3605 32.5448 40.1708 32.9114 40.1708 33.3318C40.1708 33.7522 40.3605 34.1316 40.8322 34.1316ZM44.0134 34.6187V30.9965H45.1849C45.8617 30.9965 46.4385 31.3835 46.4385 32.0629C46.4385 32.5192 46.1411 32.8652 45.731 33.0062L46.7384 34.6187H45.9924L45.1003 33.0703H44.8901H44.6646V34.6187H44.0134ZM44.6697 32.5397H45.2439C45.59 32.5243 45.795 32.3448 45.795 32.0731C45.795 31.7732 45.5618 31.5784 45.1901 31.5784H44.6697V32.5397ZM47.1537 31.5732V30.9965H47.8099V31.5732H47.1537ZM47.1691 34.6187V32.0577H47.7946V34.6187H47.1691ZM49.4429 34.6699C48.7225 34.6699 48.3329 34.0521 48.3329 33.3369C48.3329 32.6294 48.7225 32.0039 49.4326 32.0039C49.6992 32.0039 49.9838 32.0936 50.1606 32.3141V30.9965H50.7964V34.6187H50.2145L50.1863 34.329C50.0094 34.5725 49.7249 34.6699 49.4429 34.6699ZM49.5941 34.1034C50.0248 34.1034 50.2145 33.7727 50.2145 33.3369C50.2145 32.9063 50.0248 32.5704 49.5941 32.5704C49.1635 32.5704 48.9686 32.9114 48.9686 33.3369C48.9686 33.7676 49.1635 34.1034 49.5941 34.1034ZM52.619 34.6699C51.7372 34.6699 51.3219 34.0367 51.3219 33.3472C51.3219 32.6807 51.7115 32.0039 52.578 32.0039C53.4752 32.0039 53.7649 32.7242 53.7649 33.2959C53.7649 33.401 53.7546 33.5061 53.7418 33.542H51.9833C52.0371 33.8778 52.2217 34.1034 52.6241 34.1034C52.8549 34.1034 53.0599 34.0316 53.2394 33.8317L53.67 34.2085C53.3906 34.5187 53.0497 34.6699 52.619 34.6699ZM51.9833 33.0908H53.1497C53.1497 33.0344 53.1445 32.9806 53.1292 32.9293C53.0651 32.6653 52.8446 32.5294 52.5729 32.5294C52.2037 32.5294 52.0422 32.7704 51.9833 33.0908ZM54.2904 34.6187V32.0577H54.9005V32.4884C55.0107 32.1782 55.3004 32.0039 55.5875 32.0039C55.7567 32.0039 55.9336 32.0629 56.0566 32.1885L55.7721 32.7012C55.6875 32.6448 55.5927 32.614 55.4927 32.614C55.2004 32.614 54.8954 32.8857 54.8954 33.5369V34.6187H54.2904Z",
    fill: "#7953D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2715 53.1896C47.0069 53.1896 46.7925 53.4044 46.7925 53.6693C46.7925 53.9344 47.0069 54.1492 47.2715 54.1492C47.5362 54.1492 47.7506 53.9344 47.7506 53.6693C47.7508 53.4045 47.5363 53.1896 47.2715 53.1896ZM46.5845 47.3426C43.4889 47.2002 41.4662 48.6553 41.4662 50.9644C41.4662 51.1481 41.6149 51.2971 41.7984 51.2971H42.3073V52.0169L41.2396 54.0139C41.1844 54.1169 41.1874 54.2416 41.2474 54.3419C41.3073 54.4423 41.4155 54.5036 41.5323 54.5036H42.3072V55.7315C42.3072 56.4346 42.8783 57.0067 43.5803 57.0067H45.0196V57.5003C45.0196 57.684 45.1683 57.833 45.3517 57.833C45.5352 57.833 45.6839 57.684 45.6839 57.5003V56.7701L46.633 55.2606C47.1233 55.561 47.7402 55.7314 48.4754 55.7707V57.0443C48.4754 57.228 48.6242 57.377 48.8076 57.377C48.991 57.377 49.1398 57.228 49.1398 57.0443V55.7819H49.6771C49.789 55.7819 49.8933 55.7253 49.9547 55.6316C49.9953 55.5696 50.9502 54.0873 50.9502 51.8578C50.9501 50.7909 50.9499 47.5438 46.5845 47.3426ZM45.1683 56.3412H43.5805C43.2449 56.3412 42.9716 56.0675 42.9716 55.7313V54.1708C42.9716 53.9871 42.8229 53.8381 42.6394 53.8381H42.0869L42.9321 52.2571C42.958 52.2087 42.9716 52.1549 42.9716 52.1001V51.2968H44.3077C45.1346 51.2968 45.2238 51.9338 45.2238 52.2076C45.2238 53.3587 45.5257 54.2414 46.1106 54.8422L45.1683 56.3412ZM49.4864 55.1165H48.8075C46.8429 55.1165 45.8881 54.165 45.8881 52.2078C45.8881 51.265 45.2531 50.6316 44.3078 50.6316H42.1493C42.344 48.9341 44.0411 47.8913 46.554 48.0072C49.8615 48.1598 50.2859 50.1451 50.2859 51.8576C50.2859 53.4944 49.7101 54.707 49.4864 55.1165Z",
    fill: "#7953D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3763 43.7681C41.6471 43.7681 37.8125 47.6027 37.8125 52.3319C37.8125 57.0611 41.6471 60.8957 46.3763 60.8957C51.1056 60.8957 54.9402 57.0611 54.9402 52.3319C54.9402 47.6027 51.1056 43.7681 46.3763 43.7681ZM46.3763 59.4429C42.45 59.4429 39.2653 56.2583 39.2653 52.3319C39.2653 50.6306 39.8636 49.0669 40.8615 47.8435L50.8647 57.8468C49.6413 58.8446 48.0776 59.4429 46.3763 59.4429ZM51.8912 56.8203L41.888 46.817C43.1114 45.8192 44.675 45.2209 46.3763 45.2209C50.3027 45.2209 53.4874 48.4055 53.4874 52.3319C53.4874 54.0332 52.889 55.5969 51.8912 56.8203Z",
    fill: "#8A63F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23864_34756",
    x: 0.574469,
    y: 0.574713,
    width: 90.8511,
    height: 90.8511,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.21277
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23864_34756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23864_34756",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRiderRoutes);
export default __webpack_public_path__ + "static/media/empty_rider_routes.1a3a91c093b2fb44fe3fae85fb04ff08.svg";
export { ForwardRef as ReactComponent };